<template>
    <div>
        <div class="topPart">
            <div class="t1 flx alc bb">
                <div class="tLeft">
                    <div class="tname">
                        HR新势力小程序
                    </div>
                    <div class="tp1">
                        近期热门
                    </div>
                    <div class="tp1">
                        人力资源活动+服务
                    </div>
                    <img class="plas" :src="$Localimg('plas.png')" alt="" />
                </div>
                <div class="tImge">
                    <img :src="$img(qr2)" alt="" />
                </div>
            </div>
            <div class="t1 flx alc">
                <div class="tLeft">
                    <div class="tname">
                        HR新势力公众号
                    </div>
                    <div class="tp1">
                        汇聚新鲜的
                    </div>
                    <div class="tp1">
                        人力资源资讯和热点
                    </div>
                    <img class="plas" :src="$Localimg('plas.png')" alt="" />
                </div>
                <div class="tImge">
                    <img :src="$img(qr1)" alt="" />
                </div>
            </div>
        </div>
        <div class="bottomPart">
            <div class="bpt">
                推荐活动
            </div>
            <div class="reItem cursor" :style="index == 2?'border:none;margin-bottom:0' : ''" v-for="item,index in list" @click="toDetail(item)">
                <div class="reImg">
                    <img :src="$img(item.pc_avatar)" alt="" />
                </div>
                <div class="reInfo">
                    <div class="reName multy2" v-text="item.name">
            
                    </div>
                    <div class="readdress" v-text="item.city_name">
                        
                    </div>
                    <div class="reTitle single" v-text="item.title">
            
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getConfig,
        getActiviesList
    } from "@/api/index.js"
    export default {
        name: "asideAc",
        data() {
            return {
                qr1: "",
                qr2: "",
                list: []
            };
        },
        $route: {
          handler(to, from) {
           this.id= to.query.id
           this.cateName = to.query.name
           this.getDetail()
          },
          deep: true
        },
        created() {
            let data = {}
            data.source = 'recom'
            data.page = 1
            data.size = 3
            getConfig().then((res) => {
                if (res.code == 1) {
                    this.qr1 = res.data.gzh_qrcode
                    this.qr2 = res.data.xcx_qrcode
                }
            })
            getActiviesList(data).then((res) => {
                console.log("lsit", res)
                if (res.code == 1) {
                    this.list = res.data.list.data
                }
            })
        },
        methods: {
            toDetail(e){
                this.$router.push({
                    path: '/signDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            }
        }
    };
</script>
<style scoped>
    .reTitle{
        font-size: 14px;
        color: #919296;
    }
    .readdress{
        font-size: 12px;
        color: #007AFF;
        line-height: 19px;
        box-sizing: border-box;
        padding: 0 5px;
        background: #F4F9FF;
        display: inline-block;
        margin-bottom: 10px;
        
    }
    .reName{
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 14px;
    }
    .reItem{
        width: 100%;
        border-bottom: 1px solid #ececec;
        margin-bottom: 20px;
    }
    .reInfo{
        text-align: left;
        box-sizing: border-box;
        padding: 12px 0 20px;
    }
    .reImg{
        width: 292px;
        height: 164px;
        overflow-y:hidden
    }
    .reImg img{
        width: 100%;
        /* height: 100%; */
        border-radius: 6px;
    }
    .bpt{
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 20px;
        text-align: left;
    }
    .bottomPart {
        background: #ffffff;
        width: 332px;
        box-sizing: border-box;
        padding: 20px;
    }

    .plas {
        width: 22px;
        height: 22px;
        margin-top: 12px;
    }

    .tp1 {
        font-size: 13px;
        color: #8D90AA;
        text-align: left;
        line-height: 18px;
    }

    .tLeft {
        margin-right: 23px;
        text-align: left;
    }

    .tname {
        font-weight: bold;
        font-size: 20px;
        color: #3A3D4B;
        margin-bottom: 10px;
    }

    .tImge {
        width: 100px;
        height: 100px;
    }

    .tImge img {
        width: 100%;
        height: 100%;
    }

    .bb {
        border-bottom: 1px dashed #F2E1E1;
    }

    .t1 {
        height: 50%;
        width: 100%;
    }

    .topPart {
        box-sizing: border-box;
        padding: 0 28px;
        width: 332px;
        height: 314px;
        background: url("https://hrxsl.com/pcImages/codesBk.png") no-repeat;
        background-size: 100% 100%;
        margin-bottom: 16px;
    }
</style>